import { NgClass, NgFor, NgIf } from '@angular/common';
import { Component } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatOptionModule } from '@angular/material/core';
import { MatDialog } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';
import { FieldType } from '@ngx-formly/core';
import { cloneDeep } from 'lodash';

@Component({
    selector: 'app-select-with-modal',
    template: `
		<mat-form-field appearance="outline" class="select-with-modal-field">
			<mat-label>{{ props.label }}</mat-label>
			<div class="input-group">
				<mat-select [formControl]="formControl" [ngClass]="{ 'is-invalid': showError }">
					<mat-option *ngFor="let option of props.options" [value]="option.value">{{ option.label }}</mat-option>
				</mat-select>
			</div>
		</mat-form-field>
		<button
			*ngIf="props.addonRight && props.addonRight.icon"
			mat-icon-button
			class="btn btn-outline-secondary"
			type="button"
			(click)="openModal()"
			matSuffix
		>
			<mat-icon>{{ props.addonRight.icon }}</mat-icon>
		</button>
	`,
    styleUrls: [`./select-with-modal.less`],
    standalone: true,
    imports: [
        MatFormFieldModule,
        MatSelectModule,
        FormsModule,
        ReactiveFormsModule,
        NgClass,
        NgFor,
        MatOptionModule,
        NgIf,
        MatButtonModule,
        MatIconModule,
    ],
})
export class SelectWithModalComponent extends FieldType {
	constructor(private readonly dialog: MatDialog) {
		super();
	}

	openModal() {
		this.dialog
			.open(this.props.config.component, {
				closeOnNavigation: false,
				minWidth: '800px',
				disableClose: true,
			})
			.afterClosed()
			.subscribe((resp) => {
				if (resp.Id) {
					const items = cloneDeep(this.options.formState.selects[this.props.config.selectsKey]);
					if (!items.find((item) => item.value === resp.Id)) {
						this.options.formState.selects[this.props.config.selectsKey] = [
							...this.options.formState.selects[this.props.config.selectsKey],
							{
								label: this.props.config.labelKey ? resp[this.props.config.labelKey] : this.props.config.labelKeyFunc(resp),
								value: resp.Id,
							},
						];
					}
					this.form.controls[`${this.props.config.idKey}`].setValue(resp.Id);
				}
			});
	}
}
